// src/Sa.tsx
import { createIcon } from "@chakra-ui/icon";
import { jsx, jsxs } from "react/jsx-runtime";
var Sa_default = createIcon({
  displayName: "Sa",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsx("svg", {
    width: "50",
    height: "34",
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxs("g", {
      children: [
        /* @__PURE__ */ jsxs("g", {
          children: [
            /* @__PURE__ */ jsx("rect", {
              id: "BG",
              x: "1",
              y: "1",
              width: "48",
              height: "32",
              fill: "#00AE82"
            }),
            /* @__PURE__ */ jsx("path", {
              fill: "white",
              fillRule: "evenodd",
              d: "M22.8 9H24a1 1 0 1 1 0 2 1 1 0 0 0-1 1.2c.1.4.6.7 1 .6h.1a.3.3 0 0 1 .4.5l-.2.3a1 1 0 0 0 0 1l.2.4a.4.4 0 0 1-.5.5H24a.6.6 0 0 0-.9.5c0 .6.4 1 1 1s1 .4 1 1v.9a.3.3 0 0 1-.5.1l-.2-.4a.5.5 0 0 0-.8-.1c-.3.3-.7.3-1 0l-.8-.8a.8.8 0 0 0-1.1 0c-.4.3-.4.8-.2 1.1l.2.3a.4.4 0 0 1-.4.5l-.5-.2a1 1 0 0 1-.7-.9v-9a.5.5 0 0 1 1 0v5.8a.3.3 0 0 0 .5.2l.3-.3.3-.5.8-4.9c0-.4.5-.8 1-.8Zm12.4 0c.4 0 .9.4 1 .8l.7 4.9c0 .2.2.4.3.5l.3.3a.3.3 0 0 0 .5-.2V9.5a.5.5 0 0 1 1 0v9c0 .4-.3.8-.7 1l-.5.1a.4.4 0 0 1-.4-.5l.2-.3c.2-.3.2-.8-.2-1.1a.8.8 0 0 0-1.1 0l-.8.8c-.3.3-.7.3-1 0a.5.5 0 0 0-.8.1l-.2.4a.3.3 0 0 1-.5-.1V18c0-.6.4-1 1-1s1-.4 1-1a.6.6 0 0 0-.9-.6l-.1.1a.4.4 0 0 1-.5-.5l.2-.4a1 1 0 0 0 0-1l-.2-.3a.3.3 0 0 1 .4-.5h.1a.8.8 0 0 0 1-.8c0-.6-.4-1-1-1a1 1 0 1 1 0-2h1.2Zm-7 10.7c.4 0 .9-.4 1-.9l.7-4.8.3-.6.3-.2a.3.3 0 0 1 .5.2v5.8a.5.5 0 0 0 1 0v-9a1 1 0 0 0-.7-1l-.5-.2a.4.4 0 0 0-.4.6l.2.2c.2.4.2.9-.2 1.2-.3.2-.8.2-1.1 0l-.8-.9a.7.7 0 0 0-1 0 .5.5 0 0 1-.8 0l-.2-.4a.3.3 0 0 0-.5 0v1c0 .5.4 1 1 1s1 .4 1 1a.6.6 0 0 1-.9.5H27a.4.4 0 0 0-.5.4l.2.5c.2.3.2.7 0 1l-.2.2a.3.3 0 0 0 .4.6h.1a.8.8 0 0 1 1 .7c0 .6-.4 1-1 1a1 1 0 1 0 0 2h1.2Zm-13.4 0a1 1 0 0 1-1-.9l-.8-4v-.3l-.5-.8a.3.3 0 0 0-.5 0v5.5a.5.5 0 0 1-1 0v-9c0-.5.3-.8.7-1l.5-.2a.4.4 0 0 1 .4.6l-.2.2c-.2.4-.2.9.2 1.2.3.2.8.2 1.1 0l.8-.9c.3-.2.7-.2 1 0 .3.3.7.3 1 0l.5-.4a.6.6 0 0 1 1 .4v.6c0 .5-.4 1-1 1h-1a1 1 0 0 0-1 1 .7.7 0 0 0 1 .6l.7-.2a.3.3 0 0 1 .3.5l-.5.5a1 1 0 0 0-.2 1.1l.3 1a.5.5 0 0 1-.6.6h-.5a.4.4 0 0 0-.5.3c0 .3.2.6.5.6H17a1 1 0 1 1 0 2h-2.2ZM33 24H12.7a.3.3 0 0 0-.2.5l.6.6a3 3 0 0 0 2.1.9H33c0 .6.4 1 1 1h2.5c.8 0 1.5-.7 1.5-1.5v-1c0-.3-.2-.5-.5-.5h-3v-.5a1 1 0 0 0-.4-.8l-.3-.2a.5.5 0 0 0-.8.4V24Z",
              clipRule: "evenodd"
            })
          ]
        }),
        /* @__PURE__ */ jsx("rect", {
          id: "Outline",
          x: "0.5",
          y: "0.5",
          width: "49",
          height: "33",
          stroke: "#F1F4F8"
        })
      ]
    })
  })
});

export {
  Sa_default
};
